import Webshopkosar from './webshopkosar';
import Kostoloigenylo from './kostoloigenylo';

export default class EventsClass {

    constructor() {
        this.debounceTimers = {}; // Minden mezőnek saját timer
        this.KosarpanelItems = $('body.kosaroldal.ujkosar.ujkosar2026 .sides aside .kosar-panel-body');
        this.KosarpanelFooter = $('body.kosaroldal.ujkosar.ujkosar2026 .sides aside .kosar-panel-footer');
        this.KosarpanelBase = $('body.kosaroldal.ujkosar.ujkosar2026 .sides aside .kosar-panel-kont');

        this.radioScrollPosition = 0;
        this.orderTypeItems = $('.order-type-items').find('.select-item');

        // Közös request queue a race condition megelőzésére
        this.atvetelRequestQueue = [];
        this.atvetelRequestInProgress = false;
    }

    disableAtvetelRadio() {
        $('input[name="atvetel_helye"]').prop('disabled', true).closest('.select-item').addClass('loading');
    }

    enableAtvetelRadio() {
        $('input[name="atvetel_helye"]').prop('disabled', false).closest('.select-item').removeClass('loading');
    }

    queueAtvetelRequest(ajaxPromise) {
        return new Promise((resolve, reject) => {
            this.atvetelRequestQueue.push({ ajaxPromise, resolve, reject });
            this.processAtvetelQueue();
        });
    }

    processAtvetelQueue() {
        if (this.atvetelRequestInProgress || this.atvetelRequestQueue.length === 0) {
            return;
        }

        this.atvetelRequestInProgress = true;
        this.disableAtvetelRadio();

        const request = this.atvetelRequestQueue.shift();
        Promise.resolve(request.ajaxPromise)
            .then((...args) => {
                request.resolve(...args);
            })
            .catch((...args) => {
                request.reject(...args);
            })
            .finally(() => {
                this.atvetelRequestInProgress = false;
                this.enableAtvetelRadio();
                this.processAtvetelQueue();
            });
    }



    updateScrollBadge() {

        const hasScroll = this.KosarpanelItems[0].scrollHeight > this.KosarpanelItems[0].clientHeight;
        const isScrolledDown = this.KosarpanelItems.scrollTop() > 40;



        if (!hasScroll || isScrolledDown) {
            this.KosarpanelBase.find('.scroll-message').addClass('hidden');
        } else {
            this.KosarpanelBase.find('.scroll-message').removeClass('hidden');
        }
    };

    init() {
        var self = this;

        this.kosar = window.Webshopkosar;
        this.irszamInput = window.Irszaminput;



        $('input[name="atvetel_helye"]').on("click", (e) => {

            let targetElement = e.target;
            $('.radio-error-kont').hide();

            this.radioScrollPosition = $(targetElement).offset().top - $(window).scrollTop();

            self.kosar.changeSelectItemActive('atvetel_helye');

            let newScrollTop = $(targetElement).offset().top - this.radioScrollPosition;
            requestAnimationFrame(() => {
                window.scrollTo({
                    top: newScrollTop,
                    behavior: 'instant' // vagy 'auto', NEM 'smooth'
                });
            });

            if ($(targetElement).is(':checked')) {

                $('.page .page-body').addClass('loading');

                const savePromise = $.get('/index.php/webshop/savekosaratvetelhelyetype?atvetel_helye=' + $(targetElement).val() + "&atvetel_helye_pickup_tipus=1&t=" + (new Date().getTime()));
                self.queueAtvetelRequest(savePromise).then(() => {
                    if (!window.kosarpanelLoadStarted || window.kosarpanelLoadStarted == undefined) {
                        window.kosarpanelLoadStarted = true;
                        var isStepParameter = document.location.href.indexOf("step");
                        var stepValue = "";
                        if (isStepParameter != -1) {
                            stepValue = document.location.href.substring(isStepParameter + 5);
                        }

                        // sima kiszállítás - 0-ás
                        if (+$(targetElement).val() == 0) {
                            $('.page.szallitas .gls-versions').addClass('d-none');
                            $('.page.szallitas .gls-versions.v4-kiszallitas').removeClass('d-none');
                            $('.utanvet-option').removeClass('d-none');
                        }

                        // gls csomagpont - 7-es
                        if (+$(targetElement).val() == 7) {
                            $('.page.szallitas .gls-versions').addClass('d-none');
                            $('.page.szallitas .gls-versions.v2-csp-kartya').removeClass('d-none');
                        }

                        // postapont kiválasztás
                        if (+$(targetElement).val() == 10) {
                            Postainfo.init();
                        }

                        // posta és postpot esetén csak bankkártya
                        if (+$(targetElement).val() == 8 || +$(targetElement).val() == 10) {
                            $('input[name="order_type"]').filter('[value="2"]').prop('checked', true).trigger('click');
                        }

                        // pödör partner
                        if (+$(targetElement).val() == 5) {
                            $(targetElement).parents('.select-item').addClass('loading');
                            $.get('/index.php/webshop/getpodor_pickup_lista?t=' + (new Date().getTime()), (res) => {

                                let preSelected = $("select[name='pickup_reco_id']").data('pre-select');
                                $("select[name='pickup_reco_id'] option:not(.first-option)").remove();

                                $.each(res, function (index, optionData) {
                                    $("select[name='pickup_reco_id']").append(
                                        '<option value="' + optionData.key +
                                        '" ' + (optionData.key == preSelected ? 'selected' : '') +
                                        '>' + optionData.value + '</option>'
                                    );
                                });

                                if (preSelected) {
                                    $("select[name='pickup_reco_id']").val(preSelected);
                                }
                                $(targetElement).parents('.select-item').removeClass('loading');
                            });
                        }

                        if (+$(targetElement).val() != 7) {
                            console.log("clear gls data")
                            $('.page.szallitas .gls-valaszto-kont .gls-address').hide();
                            $('.page.szallitas .gls-valaszto-kont .gls-address .address').html("");
                            $('.page.szallitas .gls-valaszto-kont [name="pickup_gls_data"]').val("");

                            if ($('.gls-dpm').length > 0) {
                                $('.gls-dpm').removeClass('d-none');
                                $('<gls-dpm></gls-dpm>').attr('country', $('.gls-dpm').data('country')).attr('id', 'glsdpm').appendTo('.gls-dpm');
                                $('.gls-dpm-reloadbutton').addClass('d-none');
                                document.getElementById("glsdpm").addEventListener('change', function (e) {
                                    window.Glscsomagpont.onSelectedHandler(e.detail);
                                });
                            }
                        }


                        $.get('/index.php/webshop/services/kosarpanel_load?mode=2026&step=' + stepValue + '&t=' + (new Date().getTime()), (res) => {
                            $('.kosarpanel-container').html(res.html);
                            $('.kosarpanel-container').removeClass('loading');
                            $('.page .page-body').removeClass('loading');
                            $('.uj-kosar-kont .page-footer .btn').removeAttr('disabled');
                            window.kosarpanelLoadStarted = false;
                            self.listItemScrollBadgeInit();
                        });


                        $.get('/index.php/webshop/services/kosar_load_cimadatok_template?step=' + stepValue + '&t=' + (new Date().getTime()), (res) => {
                            $('.cimadatok-container').html(res);
                            console.log("swap template")
                            self.cimadatokInitEvents();

                            if ([5, 6, 8, 10].indexOf(+$(targetElement).val()) === -1) {
                                $('.utanvet-option').removeClass('d-none');
                            } else {
                                $('.utanvet-option').addClass('d-none');
                                $('input[name="order_type"]').filter('[value="2"]').prop('checked', true).trigger('click');
                            }

                        }, 'html');

                        if ([5, 6, 8, 10].indexOf(+$(targetElement).val()) === -1) {
                            $('.utanvet-option').removeClass('d-none');
                        } else {
                            $('.utanvet-option').addClass('d-none');
                            $('input[name="order_type"]').filter('[value="2"]').prop('checked', true).trigger('click');
                        }

                        this.orderTypeItems.removeClass('first-visible-item last-visible-item');
                        this.orderTypeItems.not('.d-none').first().addClass('first-visible-item');
                        this.orderTypeItems.not('.d-none').last().addClass('last-visible-item');
                    }
                });
            }
        });

        $('input[name="order_type"]').click(function () {
            $('.radio-error-kont').hide();
            self.kosar.changeSelectItemActive('order_type');

            if ($(this).is(':checked')) {
                $('.page .page-body').addClass('loading');
                $.get('/webshop/savekosarfizmodordertype?newordertype=' + $(this).val() + "&t=" + (new Date().getTime()), function () {
                    //window.location.reload();
                    if (!window.kosarpanelLoadStarted || window.kosarpanelLoadStarted == undefined) {
                        window.kosarpanelLoadStarted = true;
                        var isStepParameter = document.location.href.indexOf("step");
                        var stepValue = "";
                        if (isStepParameter != -1) {
                            stepValue = document.location.href.substring(isStepParameter + 5);
                        }
                        $.get('/index.php/webshop/services/kosarpanel_load?mode=2026&step=' + stepValue + '&t=' + (new Date().getTime()), function (res) {
                            $('.kosarpanel-container').html(res.html);
                            $('.kosarpanel-container').removeClass('loading');
                            $('.page .page-body').removeClass('loading');
                            $('.uj-kosar-kont .page-footer .btn').removeAttr('disabled');
                            window.kosarpanelLoadStarted = false;
                        });
                    }
                });
            }
        });

        $('.uj-kosar-kont .select-item').on('click', function (e) {
            if ($(e.target).closest('a, button, select, textarea, input, label, .gls-valaszto-kont').length) {
                return;
            }

            const $radio = $(this).find('input[type=radio]').first();
            if (!$radio.prop('checked')) {
                $('input[name="' + $radio.attr('name') + '"]').prop('checked', false);
                $radio.prop('checked', true).trigger('click');
            }
        });

        self.kosar.changeSelectItemActive('atvetel_helye');
        self.kosar.changeSelectItemActive('order_type');

        self.cimadatokInitEvents();

        $('input[name="submit-step4"]').on('click', function () {
            if ($('input[name="szaml_adoszam"]').val() != "" && $('input[name="szaml_adoszam"]').val().length == 13) {
                if (!Webshopkosar.adoszamInputCheck($('input[name="szaml_adoszam"]').val())) {
                    $('input[name="szaml_adoszam"]').addClass('error');
                    $('.adoszam-error').removeClass('d-none');
                } else {
                    $('input[name="szaml_adoszam"]').removeClass('error');
                    $('.adoszam-error').addClass('d-none');
                }
            } else {
                $('input[name="szaml_adoszam"]').removeClass('error');
                $('.adoszam-error').addClass('d-none');
            }
        });

        $('form#order_submit').submit(function () {
            Webshopkosar.clearSavedKosar();
        });

        // Mobile dropdown toggle - rendelés összegzése
        $('.dropdown-right-side > a').off('click').on('click', function (e) {
            e.preventDefault();
            $(this).parent().toggleClass('open');
        });

        self.irszamInput.initInput();

        setTimeout(function () {
            // Webshopkosar.saveKosarToBrowser()
        }, 2000);

        if ($(window).width() <= 991) {
            if ($(".errorMSG.aszf-error").length > 0) {
                $('html, body').animate({
                    scrollTop: $(".errorMSG.aszf-error").offset().top - 200
                }, 500);
            }
        }

        $('[data-autohide-target]').off('click').on('click', function (e) {
            e.stopPropagation();
            var target = $(this).data('autohide-target');
            var className = $(this).data('autohide-class');
            $(target).toggleClass(className);
        });

        $('.kostolo-selector-button').on('click', function (e) {
            e.preventDefault();
            window.Kostoloigenylo.kostoloSelectorOpen();
        })

        // pödör partner változtatás
        $('select[name=pickup_reco_id]').on('change', (e) => {
            const targetElement = $(e.target);
            targetElement.parents('.select-item').addClass('loading');
            $.get('/index.php/webshop/savekosaratvetelpickuprecoid?atvetel_helye=5&pickup_reco_id=' + targetElement.val() + '&t=' + (new Date().getTime()), () => {
                targetElement.parents('.select-item').removeClass('loading');
                $.get('/index.php/webshop/services/kosar_load_cimadatok_template?t=' + (new Date().getTime()), (res) => {
                    $('.cimadatok-container').html(res);
                    self.cimadatokInitEvents();
                }, 'html');
            })
        })

        this.listItemScrollBadgeInit();

        this.orderTypeItems.removeClass('first-visible-item last-visible-item');
        this.orderTypeItems.not('.d-none').first().addClass('first-visible-item');
        this.orderTypeItems.not('.d-none').last().addClass('last-visible-item');

        $('.ujkosar.ujkosar2026 .item-row input:text, .ujkosar.ujkosar2026 .item-row textarea').on('focus', (e) => {
            $(e.target).closest('.item-row').addClass('focused');
        }).on('blur', (e) => {
            $(e.target).closest('.item-row').removeClass('focused');
        });

    }

    listItemScrollBadgeInit() {
        // Régi ResizeObserver leállítása, ha van
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }

        // DOM elemek frissítése
        this.KosarpanelItems = $('body.kosaroldal.ujkosar.ujkosar2026 .sides aside .kosar-panel-body');
        this.KosarpanelFooter = $('body.kosaroldal.ujkosar.ujkosar2026 .sides aside .kosar-panel-footer');
        this.KosarpanelBase = $('body.kosaroldal.ujkosar.ujkosar2026 .sides aside .kosar-panel-kont');

        if (this.KosarpanelItems.length > 0 && this.KosarpanelFooter.length > 0) {
            // Régi eseményfigyelők leválasztása
            $(window).off('scroll');
            this.KosarpanelItems.off('scroll');
            $(window).off('resize', '**');

            $(window).on('scroll', () => {
                this.KosarpanelItems.css('max-height', (this.KosarpanelBase.height() - this.KosarpanelFooter.height()) + 'px');
            });

            this.KosarpanelItems.on('scroll', () => {
                this.updateScrollBadge()
            });

            this.resizeObserver = new ResizeObserver(() => {
                this.updateScrollBadge();
            });
            this.resizeObserver.observe(this.KosarpanelItems[0]);

            $(window).on('resize', () => {
                this.updateScrollBadge()
            });

            this.updateScrollBadge();
        }
    }

    cimadatokInitEvents() {
        $("#address_different").on('change', function () {
            const isChecked = $(this).is(":checked") ? 1 : 0;
            $("#postAddresDataDiv").toggle(!isChecked);

            $.post("/webshop/services/update_inputfields_addressdata", {
                item_id: "address_different",
                item_value: isChecked
            });

            if (isChecked) {
                const clearableFields = ['post_nev', 'post_irszam', 'post_varos', 'post_cim', 'post_emelet'];
                clearableFields.forEach(field => {
                    $(`input[name="${field}"]`).val('');
                    $.post("/webshop/services/update_inputfields_addressdata?t=" + (new Date().getTime()), {
                        item_id: field,
                        item_value: ''
                    });
                });
            }
            $(".group-title.szamlazasi-cim, .szallitasi-szamlazasi-group").toggle(!isChecked);
        });



        $("#cegkent_vasarlas").on('click', function () {
            $(".ceges-vasarlas-group").toggleClass('d-none', !$(this).is(":checked"));
        });

        $('input[name="szaml_adoszam"]').on('change blur', function () {
            if ($(this).val() != "" && $(this).val().length == 13) {
                if (!Webshopkosar.adoszamInputCheck($(this).val())) {
                    $(this).addClass('error');
                    $('.adoszam-error').removeClass('d-none');
                } else {
                    $(this).removeClass('error');
                    $('.adoszam-error').addClass('d-none');
                }
            } else {
                $(this).removeClass('error');
                $('.adoszam-error').addClass('d-none');
            }
        });

        $('input[name="szaml_adoszam"]').on('keyup', function () {
            // if ($(this).val() != "" && $(this).val().length == 13)
            // {
            //     if (!Webshopkosar.adoszamInputCheck($(this).val()))
            //     {
            //         $(this).addClass('error');
            //         $('.adoszam-error').removeClass('d-none');
            //     } else {
            //         $(this).removeClass('error');
            //         $('.adoszam-error').addClass('d-none');
            //     }
            // } else {
            //     $(this).removeClass('error');
            //     $('.adoszam-error').addClass('d-none');
            // }
        });

        $('.select-panel input[name="email"], .select-panel.cimadatok-container input, .select-panel.cimadatok-container textarea').off('keyup').on('keyup blur click', (e) => {
            const $input = $(e.target);
            const fieldName = $input.attr('name');

            if ($input.parents('.item-row').hasClass('error') && e.type === 'keyup') {
                $input.parents('.item-row').removeClass('error');
                $input.removeClass('error');
                $input.parents('.item-row').find('.errorMSG').remove();
            }

            if (this.debounceTimers[fieldName]) {
                clearTimeout(this.debounceTimers[fieldName]);
            }

            this.debounceTimers[fieldName] = setTimeout(() => {
                let item_value = $input.val();
                if ($input.attr("type") === "checkbox") {
                    item_value = $input.is(":checked") ? 1 : 0;
                }
                const item_id = $input.attr("name");
                $.post("/webshop/services/update_inputfields_addressdata?t=" + (new Date().getTime()), {
                    item_id: item_id,
                    item_value: item_value
                });
            }, 500);
        });

        if ($('body').hasClass('ujkosar2026')) {
            $('body').addClass('step-' + ($('.container-bg').data('current-step')));
        }

        General.phUpSlide();

        if ($('.select-panel input[name="email"]').length > 0) {
            if ($('.select-panel input[name="email"]').val() != "") {
                $('.select-panel input[name="email"]').parents('.item-row').find('.placeholder-text').addClass('smallest');
            }
        }

        if ($('.select-panel input.no-keyup-trigger').length > 0) {
            if ($('.select-panel input.no-keyup-trigger').val() != "") {
                $('.select-panel input.no-keyup-trigger').parents('.item-row').find('.placeholder-text').addClass('smallest');
            }
        }
        if ($('.select-panel textarea').length > 0) {
            if ($('.select-panel textarea').val() != "") {
                $('.select-panel textarea').parents('.item-row').find('.placeholder-text').addClass('smallest');
            }
        }


        if ($(".errorMSG").length > 0) {
            $('html, body').animate({
                scrollTop: $(".errorMSG:first").offset().top - ($(window).width() < 768 ? 190 : 110)
            }, 500);
        }

        $(document).on('input', 'input[name="tel"]', function () {
            let value = $(this).val();

            // minden nem szám és nem + eltávolítása
            value = value.replace(/[^0-9+]/g, '');

            // + kezelése: csak egy lehet és csak az elején
            if (value.includes('+')) {
                value = '+' + value.replace(/\+/g, '');
            }

            // ha nem az elején van a +, töröljük
            if (value.length > 0 && value[0] !== '+') {
                value = value.replace(/\+/g, '');
            }

            // max 15 számjegy
            const hasPlus = value.startsWith('+');
            let digits = value.replace(/\D/g, '').slice(0, 15);

            value = hasPlus ? '+' + digits : digits;

            $(this).val(value);
        });

        $(document).on('paste', 'input[name="tel"]', function (e) {
            e.preventDefault();

            let paste = (e.originalEvent || e).clipboardData.getData('text');

            paste = paste.replace(/[^0-9+]/g, '');

            if (paste.includes('+')) {
                paste = '+' + paste.replace(/\+/g, '');
            }

            if (paste.length > 0 && paste[0] !== '+') {
                paste = paste.replace(/\+/g, '');
            }

            const hasPlus = paste.startsWith('+');
            let digits = paste.replace(/\D/g, '').slice(0, 15);

            paste = hasPlus ? '+' + digits : digits;

            $(this).val(paste);
        });

    }
}
